import JoyUser from '../objects/JoyUser';
import JoyGroup from '../objects/JoyGroup';
import JoyField from '../types/JoyField';
import JoyObjectType from '../types/objects/JoyObjectType';
import JoyDataService, { JoyDataServiceQueryOption } from '../services/JoyDataService';
import { isJoyPropertiesArray } from '../validation/ModelValidation';
import { isString, isBoolean } from '../validation/TypeChecking';
export default class JoyUserHelper {
    /**
     * Create a new User document.
     * @param email The email of the user, string, representing a valid email address.
     * @param password The password, string.
     * @param name The name of the user, string.
     */
    static async create(email, password, name) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.user;
        data[JoyField.primaryEmail] = email;
        data[JoyField.password] = password;
        data[JoyField.name] = name;
        let result = await JoyDataService.instance.create(data);
        try {
            return new JoyUser(result);
        }
        catch (error) {
            throw Error('Invalid input data for JoyUser');
        }
    }
    /**
     * Fetch a User document.
     * @param id The identifier of the document to fetch.
     */
    static async get(id) {
        let data = new Map();
        data[JoyField.id] = id;
        data[JoyField.objectType] = JoyObjectType.user;
        let result = await JoyDataService.instance.read(data);
        try {
            return new JoyUser(result);
        }
        catch (error) {
            throw Error('Invalid input data for JoyUser');
        }
    }
    /**
     * Remove a User document.
     * @param id The identifier of the document to remove.
     */
    static async delete(id) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.user;
        data[JoyField.id] = id;
        await JoyDataService.instance.delete(data);
        return;
    }
    /**
     * Locate a User document based on the emails field.
     * @param email A valid email address.
     */
    static async findByEmail(email) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.user;
        data[JoyField.email] = email;
        let result = await JoyDataService.instance.lookup(data);
        let exists = result[JoyField.exists];
        if (!isBoolean(exists)) {
            throw Error("Invalid response data received for 'userExists'");
        }
        let response = { exists, isAnonymous: null, properties: [] };
        if (exists) {
            let isAnonymous = result[JoyField.isAnonymous];
            let properties = result[JoyField.props];
            if (isBoolean(isAnonymous) && isJoyPropertiesArray(properties)) {
                response.isAnonymous = isAnonymous;
                response.properties = properties;
            }
            else {
                throw Error("Invalid response data received for 'userExists'");
            }
        }
        return response;
    }
    /**
     * Fetch the Groups documents that this user belongs to..
     * @param userId The user id for which the groups will be fetched.
     * @param count Maximum number of documents to retrieve, 0 means all.
     * @param name String to filter groups name.
     * @param description String to filter groups description.
     */
    static async getGroups(userId, name, description, count = 0) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.group;
        data[JoyField.user] = userId;
        if (isString(name)) {
            data[JoyField.name] = name;
        }
        if (isString(description)) {
            data[JoyField.description] = description;
        }
        let options = new Map();
        options[JoyDataServiceQueryOption.limit] = count;
        let result = await JoyDataService.instance.read(data, options);
        let groups = [];
        for (const data of result) {
            try {
                groups.push(new JoyGroup(data));
            }
            catch (error) {
                throw Error('Invalid input data for JoyGroup');
            }
        }
        return groups;
    }
}
//# sourceMappingURL=JoyUserHelper.js.map